import * as React from 'react'
import { SVGProps } from 'react'

// Icon Categories/Event from "icons" page (Figma)
export const SvgReactComponent = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        {...props}
    >
        <path d="M3 20.28c0 .398.322.72.72.72h16.56a.72.72 0 0 0 .72-.72v-9.45H3v9.45ZM20.28 4.62H16.5V3.18a.18.18 0 0 0-.18-.18h-1.26a.18.18 0 0 0-.18.18v1.44H9.12V3.18A.18.18 0 0 0 8.94 3H7.68a.18.18 0 0 0-.18.18v1.44H3.72a.72.72 0 0 0-.72.72V9.3h18V5.34a.72.72 0 0 0-.72-.72Z"/>
    </svg>
);
